import { Box } from '@mui/material';
import { common } from '@mui/material/colors';
import BaseScore from 'common/components/base-score';
import BaseSlider from 'common/components/base-slider';
import { colors } from 'common/constants';
import React, { useMemo } from 'react';
interface Props {
    name: string;
    options: {
        scale: number;
        step: number;
    };
}
const QuestionScore: React.FC<Props> = ({ name, options }) => {
    //config for slider
    let { step } = options;
    const scale = options.scale;
    if (!step) step = 10;
    const marks = useMemo(() => {
        return [
            { value: 0, label: '0' },
            { value: scale, label: `${scale}` },
        ];
    }, [scale]);
    //config for score
    const answersForScore = useMemo(() => {
        return Array.from(
            { length: Math.floor(scale / step) + 1 },
            (_, index) => ({
                value: index * step,
                label: `${index * step}%`,
            })
        );
    }, [step, scale]);
    return (
        <Box>
            <Box
                sx={{
                    display: ['none', 'block'],
                }}
            >
                <BaseScore
                    name={name}
                    options={answersForScore}
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 1,
                    }}
                />
            </Box>
            <Box
                sx={{
                    display: ['block', 'none'],
                }}
            >
                <BaseSlider
                    name={name}
                    valueLabelDisplay="on"
                    step={step}
                    marks={marks}
                    valueLabelFormat={(value) => `${value}`}
                    size="medium"
                    max={scale}
                    sx={{
                        '& .MuiSlider-valueLabel': {
                            backgroundColor: common.white,
                            borderRadius: '50%',
                            color: colors.main,
                            width: '2rem',
                            height: '2rem',
                            fontSize: '0.7rem',
                            fontWeight: 600,
                            top: '-20px',
                        },
                        '& .MuiSlider-thumb': {
                            width: '32px',
                            height: '32px',
                            backgroundColor: 'var(--color-primary-light)',
                        },
                        '& .MuiSlider-markLabel': {
                            color: [common.white, common.black],
                            fontSize: [
                                '1.2rem',
                                '1.2rem',
                                '1.2rem',
                                '1.4rem',
                                '1.4rem',
                            ],
                            margin: '8px 0px',
                            fontWeight: 500,
                        },
                        '& .MuiSlider-rail': {
                            height: ['1rem'],
                            opacity: [1, 0.38],
                            backgroundColor: [common.white, '#0000001A'],
                        },
                        '& .MuiSlider-track': {
                            height: ['1rem'],
                        },
                        '& .MuiSlider-mark': {
                            display: 'none',
                        },
                    }}
                />
            </Box>
        </Box>
    );
};

export default QuestionScore;
